import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StaticImageUrlPipe } from '@rma/generic/util/environment';
import { FeatureFlags, FeatureFlagService } from '@rma/generic/util/feature-flags';

@Component({
  selector: 'rma-site-header-logo',
  imports: [RouterLink, StaticImageUrlPipe, AsyncPipe],
  templateUrl: './logo.component.html',
  host: {
    class: 'mt-2', // to deal with center alignment with the speech bubble tick
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteHeaderLogoComponent {
  private readonly featureFlagService = inject(FeatureFlagService);

  public readonly renownedBranding = input<boolean | null>(false);
  public readonly loginHeader = input<boolean | null>(false);
  //replace with getRenownedPathFromTenant() when its in common ui
  public readonly renownedUrl = this.featureFlagService.getFeature$<string>(FeatureFlags.RenownedBaseUrl, 'https://www.renowned.com/');
  
}
